import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Link } from '@vk-hr-tek/ui/Link';
import { FormatService } from '@vk-hr-tek/core/format';
import { GroupAvatar } from '@vk-hr-tek/ui/GroupAvatar';
import { useInject } from '@vk-hr-tek/core/ioc';

import { modules } from '@app/modules';

import { ImageParams, SearchCommunityPostOption } from '../SearchInput.types';
import { useUrlWithPrefix } from '../../../../hooks';

import { SearchOptionMeta } from './SearchOptionMeta';

interface SearchOptionCommunityPostProps {
  option: SearchCommunityPostOption;
  loadImage: (params: ImageParams) => Promise<string>;
}

export const SearchOptionCommunityPost = ({
  option,
  loadImage,
}: SearchOptionCommunityPostProps) => {
  const format = useInject(FormatService);
  const urlWithPrefix = useUrlWithPrefix();
  const href = `/${modules.community.basename}/${option.community_id}/${option.community_slug}/post/${option.id}`;

  const handleLoadImage = async () => {
    if (!option.avatar_attachment_id) {
      return undefined;
    }

    return loadImage({ id: option.avatar_attachment_id });
  };

  const labels = [{ label: option.community_title, isShrink: true }];

  if (option.user) {
    const formattedUserShortName = format.toShortName(
      option.user.first_name,
      option.user.middle_name,
      option.user.second_name,
    );
    labels.push({ label: formattedUserShortName, isShrink: true });
  }

  return (
    <Box width="100%" p="8">
      <Link {...urlWithPrefix(href)} variant="simple" display="block">
        <Box width="100%" display="flex" gap="12">
          <Box minHeight="40px" minWidth="40px" height="40px" width="40px">
            <GroupAvatar loadImage={handleLoadImage} size="small" />
          </Box>
          <Box
            flex={1}
            display="flex"
            flexDirection="column"
            gap="2"
            maxHeight="60px"
          >
            <SearchOptionMeta labels={labels} date={option.date} />
            <Box>
              <Typography
                maxLinesCount={2}
                variant="body3"
                color="text.light.primary"
                wordBreak="break-all"
              >
                {option.title}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Link>
    </Box>
  );
};
